import { useState } from "react";
const  Video = ({img, video}) => {
  console.log(img)
  const [playVideo, setPlayVideo] = useState(false);
  return (
    <div className="px-4">
      
      <div className="w-full max-w-4xl mx-auto mb-20 overflow-hidden rounded-2xl ">
        <div
          onClick={() => setPlayVideo(!playVideo)}
          style={{background:`url(${img}) no-repeat`,  backgroundSize:'cover', objectFit: "cover", height: '405px',
          backgroundPosition: '0 0'}}
          className={`h-[350px] relative  ${img !== '' ? 'cursor-pointer': 'invisible'} bg-cover video`}>
          {!playVideo && (
            <button className="absolute inset-auto text-white transform -translate-x-1/2 -translate-y-1/2 w-28 h-28 top-1/2 left-1/2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-28 h-28"
                viewBox="0 0 20 20"
                fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="sr-only">Play Video</span>
            </button>
          )}
          {playVideo && (
            <iframe
            
            className="w-full h-full"
              src={video}
              title="YouTube video player"
              frameborder="0"
              allow="oversized-images; sync-script; sync-xhr; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; layout-animations; legacy-image-formats; fullscreen"
              allowfullscreen controls
              ></iframe>
          )}
        </div>
      </div>
    </div>
  );
}

export default Video;